/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiUpdateGroupsForUserRequestFromJSON(json) {
    return StreemApiUpdateGroupsForUserRequestFromJSONTyped(json, false);
}
export function StreemApiUpdateGroupsForUserRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'groups': !exists(json, 'groups') ? undefined : json['groups'],
    };
}
export function StreemApiUpdateGroupsForUserRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'groups': value.groups,
    };
}
//# sourceMappingURL=StreemApiUpdateGroupsForUserRequest.js.map